export default __webpack_public_path__ + "static/media/ataturk.6fc2c2a4.png";